import script from "./ArticleTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleTitle.vue?vue&type=script&setup=true&lang=js"

import "./ArticleTitle.vue?vue&type=style&index=0&id=3c1a04e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1a04e6"]])

export default __exports__